import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { HttpParamObject } from './http-param-object.interface';

@Injectable({ providedIn: 'root' })
export class HttpUtilityService {
	static toPlainHttpParams(objectToConvert: object): HttpParamObject {
		return {
			params: new HttpParams({ fromObject: { ...objectToConvert } })
		};
	}

	static toCommaSeparatedHttpParams(
		arrayToConvert: Array<string>,
		paramsName: string
	): HttpParamObject {
		return {
			params: new HttpParams().append(paramsName, arrayToConvert.join(','))
		};
	}
}
